export const isChrome = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent);
export const isEdge = /Edg/.test(navigator.userAgent);
export const isFirefox = /Firefox/.test(navigator.userAgent);
export const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
